import { render } from "./storeSuccess.vue?vue&type=template&id=36597bc4"
import script from "./storeSuccess.vue?vue&type=script&lang=js"
export * from "./storeSuccess.vue?vue&type=script&lang=js"

import "./storeSuccess.vue?vue&type=style&index=0&id=36597bc4&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__